export default __webpack_public_path__ + "static/media/creditcard-plus-tilted.a23a43a0.svg";